import { UserInvite, UserInviteListItem } from '../../types'

export const userInvites: UserInvite[] = [
	{ email: 'test@example.com' },
	{ email: 'test2@example.com' }
]

export const userInviteListItems: UserInviteListItem[] = [
	{
		email: 'test@example.com',
		organizations: [{ id: 1, name: 'SP 1' }],
		organization_type: 'service_provider'
	},
	{
		email: 'test2@example.com',
		organizations: [{ id: 2, name: 'SP 2' }],
		organization_type: 'service_provider'
	}
]
